export default "__VITE_ASSET__ClBjQ0ZK__"